module.exports = __webpack_public_path__ + "9a8e39e4412cc9b57b97481ad94231c4.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-mediumitalic.ttf
 ** module id = 15
 ** module chunks = 0
 **/